import React from 'react';
import PropTypes from 'prop-types';
import './ErrorMessageField.scss';
function ErrorMessageField(_ref) {
  var errorMessage = _ref.errorMessage,
    showMessage = _ref.showMessage;
  if (!showMessage) {
    return null;
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "error-message"
  }, errorMessage);
}
ErrorMessageField.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  showMessage: PropTypes.bool.isRequired
};
export default ErrorMessageField;